import Icon from '../components/Icon.vue'

Icon.register({
  weight: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64h-384c-35.3 0-64-28.7-64-64v-320c0-35.3 28.7-64 64-64h26c-16.4 28.3-26 61-26 96 0 105.9 86.1 192 192 192s192-86.1 192-192c0-35-9.6-67.7-26-96h26zM256 320c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zM255.7 168.1c-21.9 0.2-39.7 18-39.7 39.9 0 22.1 17.9 40 40 40s40-17.9 40-40c0-10.5-4.3-20-11-27.2l33.7-78.5c3.5-8.1-0.3-17.5-8.4-21-8.1-3.5-17.5 0.2-21 8.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/weight.js
// module id = 2105
// module chunks = 0